import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("gtarp_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// Normalize FastAPI validation error responses so React never renders raw objects
client.interceptors.response.use(
  (r) => r,
  (err) => {
    const d = err?.response?.data?.detail;
    let msg;
    if (Array.isArray(d)) {
      msg = d.map((e) => (e?.msg ? `${(e.loc || []).slice(-1)[0] || ""} ${e.msg}`.trim() : String(e))).join(", ");
    } else if (typeof d === "string") {
      msg = d;
    } else if (d && typeof d === "object") {
      msg = JSON.stringify(d);
    } else {
      msg = err?.message || "Request failed";
    }
    if (err.response) err.response.data = { ...err.response.data, detail: msg };
    return Promise.reject(err);
  },
);

export default client;

export const setToken = (t) => {
  if (t) localStorage.setItem("gtarp_token", t);
  else localStorage.removeItem("gtarp_token");
};

export const setKind = (k) => {
  if (k) localStorage.setItem("gtarp_kind", k);
  else localStorage.removeItem("gtarp_kind");
};

export const getKind = () => localStorage.getItem("gtarp_kind");

export const logout = () => {
  setToken(null);
  setKind(null);
};

export const getVisitorId = () => {
  let v = localStorage.getItem("gtarp_visitor");
  if (!v) {
    v = crypto.randomUUID();
    localStorage.setItem("gtarp_visitor", v);
  }
  return v;
};
